import { WALLET_SUPPORT_PHONE_NUMBERS } from 'constants/wallet';

export const getWalletSupportPhoneNumber = country =>
  WALLET_SUPPORT_PHONE_NUMBERS[country] || WALLET_SUPPORT_PHONE_NUMBERS.default;
